module.exports = __webpack_public_path__ + "img/pay2-pic11.e2623419.png";